import { env } from './env';

export const APP = {
  name: env.appName,
  /** Shown in the footer; helps support tie a report to a deploy. */
  version: __APP_VERSION__,

  ui: {
    /** Matches the transition durations in the shared token file. */
    toastDurationMs: 4000,
    debounceMs: 300,
  },
} as const;
